<!-- 个人签名 -->
<template>
    <page-container class="personal-signatory"
                    :class="{ 'content': !hideNavigate}">
        <el-breadcrumb slot="header"
                       separator="/"
                       v-if="!hideNavigate">
            <el-breadcrumb-item :to="{ path: '/home' }"
                                replace>电子印章</el-breadcrumb-item>
            <el-breadcrumb-item><a>个人签名</a></el-breadcrumb-item>
        </el-breadcrumb>

        <div class="header">
            <el-button class="grey-text small-font"
                       type="text"
                       v-if="!hideNavigate"
                       @click="$router.push('/home')">&lt; 返回上一页</el-button>
        </div>
        <div class="signatory-container text-center">
            <h4 v-if="imageUrl">我的个人签名</h4>
            <h4 v-else>您还未设置个人签名</h4>

            <div class="seal-image-box transform-center">
                <img :src="imageUrl"
                     alt="">
            </div>

            <p class="text-center">
                <el-button type="primary"
                           size="medium"
                           @click="showCreateDialog = true"><span v-if="imageUrl">重新</span>制作个人签名</el-button>
                <el-button
                    v-if="sealId"
                    type="default"
                    size="medium"
                    @click="deleteSeal">
                    删除个人签名
                </el-button>
            </p>

        </div>

        <create-seal :visible.sync="showCreateDialog"
                     @onConfirm="autoCreate"
                     @updateImg="getSealImage"
                     v-if="showCreateDialog"></create-seal>
    </page-container>
</template>

<script>
import qs from 'qs';
import PageContainer from '../../components/container.vue';
import CreateSeal from './childs/create-personal-seal.vue';

export default {
    name: 'PersonalSignatory',
    components: { PageContainer, CreateSeal },
    data () {
        return {
            imageUrl: '',
            timer: 0,
            showCreateDialog: false,
            sealId: '',
        };
    },
    computed: {
        quser () {
            return this.$store.getters.quser;
        }
    },
    props: {
        hideNavigate: Boolean
    },
    watch: {
        showCreateDialog (nv) {
            if (nv) {
                this.handleProgress();
            } else {
                clearInterval(this.timer);
            }
        }
    },
    mounted () {
        this.getSealImage();
    },
    methods: {
        async deleteSeal() {
            let resp, loading;
            try {
                loading = this.$loading({
                    text: '删除中...'
                });
                const data = qs.stringify({ id: this.sealId });
                resp = await this.axios({
                    url: '/seal/delete',
                    method: 'POST',
                    data
                });
                resp = resp.data;
                if (resp.code === 0) {
                    this.$message.success('删除成功!');
                    this.getSealImage();
                } else {
                    this.$message.error(resp.message);
                }
            } catch (error) {
                console.log(error);
            } finally {
                loading && loading.close();
            }
        },
        async getSealImage (timer = Date.now()) {
            let resp;
            try {
                resp = await this.axios({
                    url: '/seal/personal',
                    method: 'GET'
                });
                resp = resp.data;
                if (resp.code === 0) {
                    this.sealId = resp.result?.id ?? '';
                    this.imageUrl = resp.result?.sealKey ? `${this.BASE_APP_PATH}/seal/image?fileKey=${resp.result.sealKey}&time=${timer}` : '';
                }
            } catch (error) {
                console.log(error);
            }
        },

        async autoCreate (type) {
            let resp, loading;
            try {
                loading = this.$loading({
                    text: '生成中...'
                });
                resp = await this.axios({
                    url: '/seal/create/personalseal',
                    method: 'GET',
                    params: { shape: type }
                });
                resp = resp.data;
                if (resp.code === 0) {
                    this.$message.success('生成成功!');
                    this.showCreateDialog = false;
                    this.getSealImage();
                } else {
                    this.$message.error(resp.message);
                }
            } catch (error) {
                console.log(error);
            } finally {
                loading && loading.close();
            }
        },

        handleProgress () {
            this.getSealImage(Date.now());
            this.timer = setInterval(() => {
                this.getSealImage(Date.now());
            }, 5000);
        },
    },
    beforeDestroy () {
        clearInterval(this.timer);
    }
};
</script>

<style lang="less" scoped>
.personal-signatory {
    .header {
        padding: 20px 20px 5px;
    }
    .signatory-container {
        padding: 80px 0;

        p {
            margin-top: 20px;
        }
    }

    .seal-image-box,
    .qr-code-box {
        width: 180px;
        height: 180px;
        margin: 20px auto;
        padding: 5px;
        border: 1px solid @border-color-base;

        img {
            width: 180px;
        }
    }

    .qr-code-box {
        height: 180px;
    }

    .right-tip {
        display: inline-block;
        width: 100px;
        margin: 15px 0;
        text-align: right;
        color: @red!important;
    }
}
</style>


